import { render, staticRenderFns } from "./ModalShowMaterials.vue?vue&type=template&id=6f944e7f"
import script from "./ModalShowMaterials.vue?vue&type=script&lang=js"
export * from "./ModalShowMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports